export class UnavailabilityError extends Error {}